import type { ReactNode } from "react";
import { cn } from "../lib/cn";

const BADGE_TONES = {
  neutral: "bg-zinc-700 text-zinc-200",
  green: "bg-emerald-900 text-emerald-200",
  yellow: "bg-amber-900 text-amber-200",
  red: "bg-red-900 text-red-100",
  blue: "bg-sky-900 text-sky-200",
} as const;
export type BadgeTone = keyof typeof BADGE_TONES;

export function Badge({
  tone = "neutral",
  children,
  className,
}: {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded px-1.5 py-0.5 text-[11px] font-medium",
        BADGE_TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
